import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { useMilkMoney, formatMonthLabel } from './MilkMoneyContext'
import { useTranslation } from 'react-i18next'

const MilkMoneyFilters: React.FC = () => {
  const { t } = useTranslation()
  const { milkMoneyOptions, selectedFarmer, selectedMonth, setSelectedFarmer, setSelectedMonth } = useMilkMoney()

  const farmerOptions = (milkMoneyOptions?.farmers ?? []).map((farmer) => ({
    key: farmer.farmerId,
    value: farmer.farmerId,
    text: farmer.companyName
  }))

  const monthOptions = (milkMoneyOptions?.months ?? []).map((m) => ({
    key: String(m.key),
    value: String(m.key),
    text: formatMonthLabel(m.key)
  }))

  return (
    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', justifyContent: 'flex-end' }}>
      <Dropdown
        selection
        options={farmerOptions}
        value={selectedFarmer}
        onChange={(_, { value }) => setSelectedFarmer(value as string)}
        placeholder={t('Choose farm')}
      />
      <Dropdown
        selection
        options={monthOptions}
        value={selectedMonth}
        onChange={(_, { value }) => setSelectedMonth(value as string)}
        placeholder={t('Select month')}
      />
    </div>
  )
}

export default MilkMoneyFilters
